import React from 'react';
import { FiInfo, FiLock, FiPlayCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ProgressAccuracy } from './ProgressAccuracy';

import { ProgressMeter } from './ProgressMeter';
import { Table } from './Table';

const ModulesListTable = styled(Table)`
   .exercise-name-cell a {
      line-height: 1.3;
   }
`;

const ModulesList = ({
   exerciseId,
   modules,
   hideAccuracy,
   mainExerciseLevel,
   moduleProgress,
}) => {
   if (modules == null) {
      return null;
   }

   return (
      <ModulesListTable className="module-list">
         <thead>
            <tr>
               <th className="exercise-name-head">Name</th>
               <th className="exercise-progress-head">Level</th>
               {!hideAccuracy && (
                  <th className="exercise-accuracy-head">Accuracy</th>
               )}
               <th className="exercise-actions-head" />
            </tr>
         </thead>
         <tbody>
            {modules.map(({ id, title, levelCount, unlockAfter }) => {
               const progress = moduleProgress[id];
               const hasAuxProgress = progress && progress.accuracy != null;

               return (
                  <tr key={id}>
                     <th className="exercise-name-cell">
                        <Link to={`/app/catalog/exercise/${exerciseId}/${id}`}>
                           {title}
                        </Link>
                     </th>

                     <td className="exercise-progress-cell">
                        <div className="mini-progress-wrapper">
                           <ProgressMeter
                              progress={
                                 (hasAuxProgress ? progress.currentLevel : 0) /
                                 levelCount
                              }
                           />
                           <span>
                              {hasAuxProgress ? progress.currentLevel : 0}/
                              {levelCount}
                           </span>
                        </div>
                     </td>

                     {!hideAccuracy && (
                        <td className="exercise-accuracy-cell">
                           {progress?.accuracy != null ? (
                              <ProgressAccuracy
                                 small
                                 accuracy={progress.accuracy}
                              />
                           ) : (
                              <p className="exercise-no-accuracy">N/A</p>
                           )}
                        </td>
                     )}
                     <td className="exercise-actions-cell">
                        <Link
                           className="icon-link"
                           to={`/app/catalog/exercise/${exerciseId}/${id}`}
                        >
                           <FiInfo size="1.5em" />
                        </Link>
                        {mainExerciseLevel > unlockAfter ? (
                           <Link
                              className="icon-link"
                              to={`/app/exercise/${exerciseId}/${id}`}
                           >
                              <FiPlayCircle size="1.5em" />
                           </Link>
                        ) : (
                           <FiLock
                              size="1.5em"
                              className="exercise-locked"
                              title={`Unlock by completing level ${unlockAfter} in main exercise`}
                           />
                        )}
                     </td>
                  </tr>
               );
            })}
         </tbody>
      </ModulesListTable>
   );
};

export { ModulesList };
